import React, { FC } from 'react';
import styles from './Header.scss';
import { HeaderLogo } from './HeaderLogo';
import { HeaderProgress } from './HeaderProgress';
import { useIsMobile } from 'hooks/useIsMobile';

export const Header: FC = () => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <div className={styles.header}>
        <div className={styles.headerLogoContainer}>
          <HeaderLogo />
        </div>
        <div className={styles.headerProgressContainer}>
          <HeaderProgress />
        </div>
      </div>
    );
  }

  return (
    <div className={styles.header}>
      <HeaderLogo />
      <HeaderProgress />
    </div>
  );
};
